// ##### 23-03-29 Komarov
import axios from 'axios';
// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// ##### Komarov 2025-07-14
const EmailNotify = ({ smart_service_id, cart, watchedFormData }) => {
  const me = 'EmailNotify';
  const { user: currentUser } = useSelector(state => state.auth);

  const {
    buyerPrefix,
    buyerFirstName,
    buyerLastName,
    buyerPhone,
    buyerEmail,
    travelersData,
  } = watchedFormData;

  const travelersObject = {};

  travelersData.forEach(traveler => {
    travelersObject[`Traveler ${traveler.site_client_id} prefix`] =
      traveler.travelerPrefix;
    travelersObject[`Traveler ${traveler.site_client_id} name`] =
      traveler.travelerFirstName;
    travelersObject[`Traveler ${traveler.site_client_id} surname`] =
      traveler.travelerLastName;
    travelersObject[`Traveler ${traveler.site_client_id} category`] =
      traveler.travelerCategory;
  });

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### Komarov 2025-07-21
    const data = {
      City: decodeURIComponent(cart?.cityName),
      Hotel: cart?.htlName || 'No info',
      Room: cart?.room_name || 'No info',
      Tariff: cart?.tariff_type_name || 'No info',
      NRF: cart?.nrf || 'No info',
      Adults: cart?.adults || 'No info',
      Children: cart?.children || 'No info',
      Amount: cart?.amount || 'No info',
      Currency: cart?.selected_currency || 'No info',
      Start: cart?.start || 'No info',
      End: cart?.end || 'No info',
      'Number of Rooms': cart?.numberofunits || 'No info',
      "Buyer's prefix": buyerPrefix,
      "Buyer's name": buyerFirstName,
      "Buyer's surname": buyerLastName,
      "Buyer's phone": buyerPhone,
      "Buyer's email": buyerEmail,
      ...travelersObject,
    };

    axios.post(
      // ##### 26-07-30 Komarov
      `${process.env.REACT_APP_URL}online_summary`,
      JSON.stringify({ data }),
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }, [
    currentUser.user_id,
    smart_service_id,
    buyerPrefix,
    buyerFirstName,
    buyerLastName,
    buyerPhone,
    buyerEmail,
    cart?.htlName,
    cart?.room_name,
    cart?.tariff_type_name,
    cart?.nrf,
    cart?.adults,
    cart?.children,
    cart?.amount,
    cart?.selected_currency,
    cart?.start,
    cart?.end,
    cart?.numberofunits,
    cart?.cityName,
    travelersData.length,
  ]);

  return <>{/* <div>Email sent.</div> */}</>;
};

export default EmailNotify;
